export default "__VITE_ASSET__dc42c7b5__"